<template>
    <div :class="['vr-icon', {'is-open': isOpen}]">
        <div @click="isOpen = true" class="vr-icon__svg-wrap">
            <svg class="vr-icon__svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                <path class="vr-icon__svg-circle" fill-rule="evenodd" clip-rule="evenodd" d="M23 49C35.1503 49 45
                    39.1503 45 27C45 14.8497 35.1503 5 23 5C10.8497 5 1 14.8497 1 27C1 39.1503 10.8497 49 23 49Z" />
                <path class="vr-icon__svg-i" fill-rule="evenodd" clip-rule="evenodd" d="M23 17.375C22.2406 17.375
                    21.625 17.9906 21.625 18.75V20.4306C21.625 21.1899 22.2406 21.8056 23 21.8056C23.7594 21.8056 24.375
                    21.1899 24.375 20.4306V18.75C24.375 17.9906 23.7594 17.375 23 17.375ZM23 25.1285C22.2406 25.1285
                    21.625 25.7441 21.625 26.5035V35.9375C21.625 36.6969 22.2406 37.3125 23 37.3125C23.7594 37.3125
                    24.375 36.6969 24.375 35.9375V26.5035C24.375 25.7441 23.7594 25.1285 23 25.1285Z" />
                <path class="vr-icon__svg-minicircle" d="M39 22C45.0751 22 50 17.0751 50 11C50 4.92487 45.0751 0 39
                    0C32.9249 0 28 4.92487 28 11C28 17.0751 32.9249 22 39 22Z" />
                <path d="M33.6445 8.9314L35.9139 13.5504L38.0873 8.9314" stroke="white" stroke-width="1.375"
                    stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M40.793 13.5504V8.9314C40.793 8.9314 40.8976 8.9314 42.5486 8.9314C44.1997 8.9314 44.2929
                    10.543 43.8869 11.0437C43.481 11.5445 42.643 11.8383 42.643 11.8383L44.0324 13.5504" stroke="white"
                    stroke-width="1.375" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>

        <div class="vr-icon__content">
            <div @click="isOpen = false" class="vr-icon__close">
                <ButtonClose :modify="'button-close_theme_white'" />
            </div>
            <div class="vr-icon__banner">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonClose from '../button-close/ButtonClose';

export default {
    data() {
        return {isOpen: false};
    },

    components: {ButtonClose}
};
</script>
